var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "top" }, [
      _c("img", {
        attrs: { id: "logo", src: _vm.staticUrl + "logo/T9LOGO.png" },
        on: { click: _vm.initDoc }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "playerBox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.playerID,
              expression: "formData.playerID"
            }
          ],
          staticClass: "idType",
          attrs: { maxlength: "36", placeholder: "dev1001 or dev1002" },
          domProps: { value: _vm.formData.playerID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.formData, "playerID", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.isDevEnv
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputAmount,
                  expression: "inputAmount"
                }
              ],
              staticClass: "idType",
              attrs: { maxlength: "36", placeholder: "0-10000000" },
              domProps: { value: _vm.inputAmount },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.inputAmount = $event.target.value
                }
              }
            })
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "bgBox" }),
      _vm._v(" "),
      _c("div", { staticClass: "gameList" }, [
        _c("div", { staticClass: "rowSize" }, [
          _c("div", { staticClass: "gameBoxLi" }, [
            _c("div", {
              staticClass: "gameBox eventbox",
              on: {
                click: function($event) {
                  return _vm.eventLobby()
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "gameNameBox" }, [_vm._v("Lucky兔U")])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom" }, [
      _c("span", { staticClass: "versionTxt" }, [_vm._v("Version ⚅ 1.2.1")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29aa986d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29aa986d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArWebSample.vue
// module id = null
// module chunks = 